import { ExecutionPath } from '../models';
import {
  UserClickedExecutedNodeAction,
  ProcessUserSelectedElementAction,
  ProcessUserSelectedPathAction, UserChangedPathAction
} from '../store/actions';
import { Injectable } from '@angular/core';
import { Node } from '../models';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { ExecutedPathUtils } from '@ispm-client/modules/process-executor/services/executed-path-utils';
import { Shape } from 'diagram-js/lib/model';
import { NodeSelectionMode } from '@ispm-client/modules/process-executor/models/tree-navigation-configuration';

@Injectable()
export class UserClicksElementsService {

  public getAppropriateAction(executionPath: ExecutionPath, element: any, nodesSelectionMode: NodeSelectionMode) {
    if (!ModelingUtil.isSelectableShapeType(element)) {
      return null;
    }
    if (nodesSelectionMode !== NodeSelectionMode.directChildren) {
      if (this.isNodeUnclickable(executionPath, element.id)) {
        return null;
      }
      const pathNodeIds: string[] = executionPath.executedNodes.map(node => node.nodeId);
      if (executionPath.currentUserTaskHolder) {
        pathNodeIds.push(executionPath.currentUserTaskHolder.nodeId);
      }
      const pathFromAncestor: Node[] = this.getPathFromNearestCommonAncestor(pathNodeIds, element);
      const ancestorId: string = pathFromAncestor[0].nodeId;
      if (executionPath.currentUserTaskHolder && executionPath.currentUserTaskHolder.nodeId === ancestorId) {
        return new ProcessUserSelectedPathAction({ pathFromCommonAncestorToSelected: pathFromAncestor });
      } else {
        return new UserChangedPathAction({ pathFromCommonAncestorToSelected: pathFromAncestor });
      }
    }

    if (this.getGoingForwardSelectableNodes(executionPath).find(node => node.nodeId === element.id)) {
      return new ProcessUserSelectedElementAction({
        id: element.id,
        name: element.businessObject.name
      });
    }

    if (this.getGoingBackSelectableNodes(executionPath).find(node => node.nodeId === element.id)) {
      return new UserClickedExecutedNodeAction({
        id: element.id
      });
    }
    return null;
  }

  private getPathFromNearestCommonAncestor(pathNodeIds: string[], shape: Shape): Node[] {
    const node: Node =  ExecutedPathUtils.convertShapeToNode(shape);
    if (pathNodeIds.find(pathNodeId => pathNodeId === node.nodeId)) {
      return [node];
    }
    let nearestCommonAncestorIndex = -1;
    let pathFromNearestCommonAncestor: Node[] = null;
    const parents: Shape[] = ModelingUtil.getNodeParents(shape);
    if (parents && parents.length > 0) {
      parents.forEach(parent => {
        const path: Node[] = this.getPathFromNearestCommonAncestor(pathNodeIds, parent);
        const ancestor: Node = path[0];
        const index = pathNodeIds.indexOf(ancestor.nodeId);
        if (index > nearestCommonAncestorIndex) {
          path.push(node);
          nearestCommonAncestorIndex = index;
          pathFromNearestCommonAncestor = path;
        }
      });
    }
    return pathFromNearestCommonAncestor;
  }

  public getGoingForwardSelectableNodes(executionPath: ExecutionPath): Node[] {
    return executionPath.nodesForSelection;
  }

  public getGoingBackSelectableNodes(executionPath: ExecutionPath): Node[] {

    if (executionPath.executedTreatmentTaskId) {
      return executionPath.executedNodes.slice(0, executionPath.executedNodes.length - 1);
    } else {
      return executionPath.executedNodes;
    }
  }

  public getAllSelectableNodes(executionPath: ExecutionPath):  Node[] {
    return this.getGoingBackSelectableNodes(executionPath).concat(this.getGoingForwardSelectableNodes(executionPath));
  }

  private isNodeUnclickable(executionPath: ExecutionPath, elementId: string): boolean {
    return (executionPath.currentUserTaskHolder && executionPath.currentUserTaskHolder.nodeId === elementId) ||
      (executionPath.executedTreatmentTaskId && (executionPath.executedTreatmentTaskId === elementId ||
      executionPath.executedNodes[executionPath.executedNodes.length - 1].nodeId === elementId));
  }
}
